/**
 * Shutdown Intercom and clear all related data
 * This is the main function to call during logout
 */
export const shutdownIntercom = (): void => {
    if (window.Intercom) {
        window.Intercom('shutdown');
    }
};
